import "../../assets/styles/main.scss";
import "./index.scss";

import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setOpenedModal } from "../../redux/actions";
import Mission from "../../components/Mission";
import Match from "../../components/Match";
import Galleries from "../../components/Galleries";
import Gallery from "../../components/Gallery";
// import Proof from "../../components/Proof";
import Footer from "../../components/Footer";
import animation from "../../animation";

const Main = ({ setOpenedModal }) => {
  useEffect(() => {
    document.querySelector("html").scrollTop = 0;
    document.querySelector("html").style.overflowY = "hidden";
    document.documentElement.scrollTop = 0;

    const wholePath = window.location.pathname;
    let pathname = wholePath ? wholePath.replace(/\//g, "") : "";

    if (!["contactus", "support", "artup-support"].includes(pathname)) {
      window.history.replaceState({}, document.title, "/");
      pathname = "";
    }

    animation.mission();
    animation.match();
    animation.gallery();
    animation.galleries();
    // animation.proof();
    animation.starting(pathname);
  }, []);

  return (
    <div className={`main`}>
      <Mission />
      <Gallery setOpenedModal={() => setOpenedModal("gallery")} />
      <Galleries />
      <Match setOpenedModal={() => setOpenedModal("match")} />
      {/* <Proof setOpenedModal={() => setOpenedModal("proof")} /> */}
      <Footer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setOpenedModal: (value) => dispatch(setOpenedModal(value)),
});

export default connect(null, mapDispatchToProps)(Main);
